import styled from 'styled-components'

import { fonts, palette } from '../../styles/variables'

export const FlipCounter = styled.div(({ gap = 20 }) => ({
  display: 'flex',
  gap: `${gap}px`,
}))

export const FlipUnitGroup = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '6px',
}))

export const FlipUnitTime = styled.div(
  ({
    isLast,
    fontFamily = fonts.primaryBold,
    fontSize = '20px',
    color = palette.white,
    fontWeight = 'lighter',
    gap = 20,
  }) => ({
    display: 'flex',
    gap: '4px',
    position: 'relative',
    '&:after': {
      content: isLast ? '""' : '" : "',
      position: 'absolute',
      left: `calc(100% + ${gap / 2}px)`,
      top: '50%',
      transform: 'translate(-50%, -50%)',
      fontFamily,
      fontSize,
      color,
      fontWeight,
    },
  }),
)

export const FlipUnitLabel = styled.div(
  ({
    color = palette.white,
    fontFamily = fonts.primary,
    fontSize = '12px',
  }) => ({
    color,
    fontFamily,
    fontSize,
    textTransform: 'uppercase',
    letterSpacing: '3px',
    marginTop: '2px',
  }),
)

export const FlipUnitWrapper = styled.div(
  ({ width = 30, height = 40, background = palette.orange70, ...rest }) => ({
    width: `${width}px`,
    height: `${height}px`,
    background,
    display: 'block',
    position: 'relative',
    perspectiveOrigin: '50% 50%',
    perspective: '300px',
    ...rest,
  }),
)

export const FlipPart = styled.div(
  ({
    background = palette.orange70,
    fontFamily = 'Courier, Droid Sans Mono, monospace',
    fontSize = '20px',
    color = palette.white,
    fontWeight = 'lighter',
  }) => ({
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    width: '100%',
    height: '50%',
    overflow: 'hidden',
    background,
    '& span': {
      fontFamily,
      fontSize,
      fontWeight,
      color,
    },
    '&.full-card': {
      height: '100%',
      alignItems: 'center',
    },
    '&.upper-card': {
      alignItems: 'flex-end',
      '& span': {
        transform: 'translateY(50%)',
      },
    },
    '&.lower-card': {
      alignItems: 'flex-start',
      '& span': {
        transform: 'translateY(-50%)',
      },
    },
  }),
)

export const FlipCard = styled.div(
  ({
    background = palette.orange70,
    fontFamily = 'Courier, Droid Sans Mono, monospace',
    fontSize = '20px',
    color = palette.white,
    fontWeight = 'lighter',
  }) => ({
    display: 'flex',
    justifyContent: 'center',
    position: 'absolute',
    left: 0,
    width: '100%',
    height: '50%',
    overflow: 'hidden',
    backfaceVisibility: 'hidden',
    '& span': {
      fontFamily,
      fontSize,
      fontWeight,
      color,
    },
    '&.unfold': {
      top: '50%',
      alignItems: 'flex-start',
      transformOrigin: '50% 0',
      transform: 'rotateX(180deg)',
      background,
      animation:
        'unfold 0.6s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s 1 normal forwards',
      transformStyle: 'preserve-3d',
      '& span': {
        transform: 'translateY(-50%)',
      },
    },
    '&.fold': {
      top: 0,
      alignItems: 'flex-end',
      transformOrigin: '50% 100%',
      transform: 'rotateX(0deg)',
      background,
      animation:
        'fold 0.6s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s 1 normal forwards',
      transformStyle: 'preserve-3d',
      '& span': {
        transform: 'translateY(50%)',
      },
    },
    '&.fold-card': {
      background,
      transform: 'rotateX(-180deg)',
      transformStyle: 'preserve-3d',
    },
    '&.unfold-card': {
      background,
      transform: 'rotateX(180deg)',
      transformStyle: 'preserve-3d',
    },
  }),
)
